import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import { CommonService } from "../../../services/common.service";
import {
  Combo2Service,
  ComboService,
  ExcelService,
  ReportService,
} from "../../../services/index";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
declare var google;

@Component({
  selector: "estimate-stock-report",
  templateUrl: "./estimateStockReport.html",
})
export class estimateStockReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  typeList = ["Wholesale", "Retail", "Estimate"];
  gridOptions: any;
  designnoList = [];
  dataList = [];
  qualityList: any;
  seasonfinList = [];
  colorList: any;
  codeList: any;
  widthList: any[];
  brandList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  exceldata: any;
  groupbyList = ["DESIGN NO", "WO NO"];
  filter: any = {
    design_no: "",
    party_name: "",
    from_date: "",
    to_date: "",
    party_id: "",
    type: "",
    groupby: "salesInvoice",
    finyear: "",
    fin_id: "",
    season_id: "",
    season: "",
    invoiceno: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "wo_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "WorkOrder Report",
    columns: [],
    rows: [],
  };

  partyList = [];

  // @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
  // @ViewChild('nameTemplate') nameTemplate: TemplateRef<any>;
  // @ViewChild('addrTemplate') addrTemplate: TemplateRef<any>;
  //   @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  //   @ViewChild('partyDataTable') partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  reportTypeList = ["DESIGN NO", "PARTY", "PURCHASE"];
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private commonserv: CommonService,
    private poservice: PurchaseOrderService,
    private excelService: ExcelService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private reportService: ReportService,
    public toasterService: ToasterService,
    public comboservice: ComboService
  ) {}

  ngOnInit(): void {
    let date = new Date();
    // this.filter.from_date = new Date(date.getFullYear(), date.getMonth(), 1);
    // this.filter.to_date = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    this.getColumns();
    this.getPartyList();
    this.finyearCombo();
    this.getSeasonList();
    this.widthlist();
    this.getDesignNoList();
    //  this.brandlist();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }
  getPartyList() {
    let params = {
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }
  widthlist() {
    this.poservice.widthlist({}).then((res: any) => {
      this.widthList = res.data;
    });
  }
  brandlist() {
    let data = this.commonserv.itemMaster();
    let brand = data.brand;
    this.brandList = brand;
    let style = data.style;
  }
  getDesignNoList() {
    let params = {};
    this.comboservice.getDesignCombo(params).then((res: any) => {
      this.designnoList = res;
    });
  }

  onCellClick(event) {
    // this.filter.design_no = event.row.design_no;
    if (this.filter.groupby == "invoiceno") {
      this.filter.groupby = "invoiceShade";
      this.filter.invoiceno = event.row.invoiceno;
      this.filter.design_no = event.row.design_no;
      this.filter.party_id = event.row.party_id;
    }
    if (this.filter.groupby == "salesInvoice") {
      this.filter.invoiceno = event.row.invoiceno;
      this.filter.party_id = event.row.party_id;
      this.filter.groupby = "invoiceno";
    }
    this.getOrderList();
  }
  onbackbutton() {
    if (this.filter.groupby == "invoiceShade") {
      this.filter.groupby = "invoiceno";
      this.filter.design_no = "";
    }
    if (this.filter.groupby == "invoiceno") {
      this.filter.invoiceno = "";
      this.filter.party_id = "";
      this.filter.groupby = "salesInvoice";
    }
    this.getOrderList();
  }

  applyFilter(): void {
    this.filter.party_id = "";
    console.log(this.filter.from_date, this.filter.to_date);

    this.getOrderList();
  }
  getinvoice(invoiceno) {
    this.filter.party_id = "";
    this.filter.groupby = "";
    this.getOrderList();
    this.filter.groupby = "partywise";
  }
  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      // that.filter.finyear = res.data[0].finyear;
      that.filter.fin_id = res.data[0].fin_id;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      that.onSelectFinyear(res.data[0].fin_id);
      that.getSeasonList();
    });
  }
  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getBrandNewSeason(params).then((res: any) => {
      this.seasonList = res;
      this.allseason();
      this.seasonCtrl.setValue(res[res["length"] - 1].season_id);
      this.getOrderList();
    });
  }
  allseason() {
    let fin_id = parseInt(this.filter.fin_id);

    this.seasonList.forEach(() => {
      let seasonAll = {
        season: "ALL",
        season_id: this.seasonList[this.seasonList["length"] - 1].season_id + 1,
        fin_id: fin_id,
      };
      if (fin_id > 0) {
        this.seasonList.push(seasonAll);
      }
      fin_id = fin_id - 1;
    });
  }
  onSelectFinyear(id) {
    this.filter.season_id = "";
    var fin_id = id;
    // let seasonfinList = _.filter(this.seasonList, fin_id );
    let seasonfinList = this.seasonList.filter((res) => res.fin_id == fin_id);
    this.seasonfinList = seasonfinList;
    this.seasonCtrl.setValue(
      this.seasonfinList[this.seasonfinList["length"] - 1].season_id
    );
    this.filter.season_id = this.seasonfinList[
      this.seasonfinList["length"] - 1
    ].season_id;
    this.filter.season = this.seasonfinList[
      this.seasonfinList["length"] - 1
    ].season;
  }
  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }
    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }
  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    list = that.seasonList;

    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      return fitem["season"];
    }
    return "";
  }
  getOrderList(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    if (this.filter.from_date || this.filter.to_date) {
      this.filter.season_id = "";
      this.filter.season = "";
    }
    //this.filter.order_to_date = this.datePipe.transform(this.filter.order_to_date, 'yyyy-MM-dd');
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .estimateInvoiceStockReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        // if(that.filter.groupby == 'invoiceShade'){
        //   that.columns.splice( 1,0,{
        //     name: "Barcode",
        //     prop: "barcode",
        //     minWidth: 180,
        //     maxWidth: 180,
        //     width: 180,
        //     headerClass: "text-center",
        //   })
        // }else{
        //   that.columns = that.columns.filter(el => {
        //     return el.prop != "barcode";
        //   })
        // }

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };

        // let menuObj = {
        //     cellClass: "txtCenter",
        //     name: "PCS%",
        //     prop: "percent",

        //     width: "90"
        //    }
        //    let menuObj1 = {
        //     cellClass: "txtCenter",
        //     name: "VAL%",
        //     prop: "percent1",

        //     width: "90"
        //    }
        //    that.gridOptions.columns.push(menuObj);
        //    that.gridOptions.columns.push(menuObj1);
        //    let arrVal =res.data;
        //    let totalCnt = 0;
        //    let totalCnt1 = 0;

        //    for(var j =0;j<arrVal.length;j++){
        //        let temp = arrVal[j];
        //    totalCnt += parseFloat(temp.tot);
        //    totalCnt1 += parseFloat(temp.totval);
        //    }
        //    for(var k =0;k<arrVal.length;k++){
        //     let temp1 = arrVal[k];
        //   let  percent:any;
        //   let  percent1:any;
        //   percent =((temp1.tot/totalCnt)*100).toFixed(2);
        // res.data[k].percent = percent;
        // percent1 =((temp1.totval/totalCnt1)*100).toFixed(2);
        // res.data[k].percent1 = percent1;
        // }
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/salesReports/sales-invoice-report/estimateStockReport.ts